import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter 
} from '../../ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '../../ui/select';
import { Undo2, Loader2 } from 'lucide-react';

export default function ModalRetrocederLote({
  open,
  onOpenChange,
  lote,
  categoriaRetrocesso,
  setCategoriaRetrocesso,
  quantidadeRetroceder,
  setQuantidadeRetroceder,
  motivoRetrocesso,
  setMotivoRetrocesso,
  saving,
  categoriasRetrocesso,
  getCategoriaCor,
  onConfirm
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Undo2 className="h-5 w-5 text-orange-600" />
            Retroceder Lote
          </DialogTitle>
          <DialogDescription>
            Retroceder peças do lote <strong>{lote?.codigo_lote || `L${lote?.numero_lote}`}</strong> para uma categoria anterior.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          {lote && (
            <div className="bg-orange-50 rounded-lg p-3 border border-orange-200">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium text-stone-700">Lote Actual</span>
                <span className={`text-xs px-2 py-0.5 rounded-full border ${getCategoriaCor(lote.categoria_codigo)}`}>
                  {lote.categoria_nome || 'Sem categoria'}
                </span>
              </div>
              <p className="text-2xl font-bold text-stone-900">{lote.quantidade} <span className="text-sm font-normal">peças</span></p>
            </div>
          )}
          
          <div>
            <label className="block text-sm font-medium mb-1">
              Quantidade a retroceder *
            </label>
            <Input
              type="number"
              min="1"
              max={lote?.quantidade || 0}
              value={quantidadeRetroceder}
              onChange={(e) => setQuantidadeRetroceder(e.target.value)}
              placeholder={`Máx: ${lote?.quantidade || 0}`}
              className="h-12"
              data-testid="input-quantidade-retroceder"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">
              Categoria de destino *
            </label>
            <Select value={categoriaRetrocesso} onValueChange={setCategoriaRetrocesso}>
              <SelectTrigger data-testid="select-categoria-retrocesso">
                <SelectValue placeholder="Selecione categoria..." />
              </SelectTrigger>
              <SelectContent>
                {categoriasRetrocesso.map(cat => (
                  <SelectItem key={cat.id} value={cat.id}>
                    <span className="flex items-center gap-2">
                      <span className="font-mono text-xs bg-stone-100 px-1 rounded">{cat.codigo || '---'}</span>
                      {cat.nome}
                    </span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">
              Motivo do retrocesso * <span className="text-xs text-stone-500">(obrigatório)</span>
            </label>
            <Textarea
              value={motivoRetrocesso}
              onChange={(e) => setMotivoRetrocesso(e.target.value)}
              placeholder="Ex: Defeito detectado, necessita retrabalho..."
              rows={2}
              className="border-orange-200 focus:border-orange-400"
            />
            <p className="text-xs text-stone-500 mt-1">Mínimo 5 caracteres</p>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            disabled={saving || !categoriaRetrocesso || !quantidadeRetroceder || motivoRetrocesso.trim().length < 5}
            className="bg-orange-600 hover:bg-orange-700"
            data-testid="btn-confirmar-retroceder"
          >
            {saving ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <Undo2 className="h-4 w-4 mr-2" />
            )}
            Retroceder Lote
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
